import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal, Image, Button, Form } from "react-bootstrap";
import Alert from "react-s-alert";
import Scrollbars from "react-custom-scrollbars";
import Media from "react-media";
//import { NavLink } from "react-router-dom";
import { MobileTopHeader } from "../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import { SliderReusableComponent } from "../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  create_and_update_restaurant,
  update_vendor_profile,
  logOutUser,
} from "../../../../store/actions/authAction";
//import isEmpty from "../../../../store/validation/is-Empty";

export const TermsAndCondition = (props) => {
  let history = useHistory();
  let dispatch = useDispatch();
  //state
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSubmit = () => setShowSuccess(true);
  const handleCloseSuccess = () => setShowSuccess(false);

  const onSubScription = (e) => {
    if (!check) {
      Alert.error(`<h4>Please agree to terms and conditions</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (props.onboarding._id && props.auth.user.VendorUser._id) {
      const formData = {
        vendor_id: props.onboarding.vendor_id,
        id: props.onboarding._id,
        terms_and_condition_accepted: true,
      };
      dispatch(create_and_update_restaurant(formData, onSuccess));
    }
  };

  const onSuccess = (e) => {
    const vendor_id = props.auth.user.VendorUser._id;
    const formData = {
      have_submited_details_yourself: false,
    };
    dispatch(update_vendor_profile(formData, vendor_id, callback));
  };

  const callback = (e) => {
    handleSubmit();
  };

  const onCombackLater = () => {
    dispatch(logOutUser());
    history.push("/");
  };
  const [check, setCheck] = useState(false);
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div
            id="onboarding-scrollbar"
            className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
          >
            <Media query="(min-width: 992px)">
              <div className="col-12">
                <BackLogoIconButton
                  displayBackText={true}
                  displayArrow={true}
                  backButtonClicked={"/bankdetailshome"}
                />
              </div>
            </Media>
            <Media query="(max-width: 991px)">
              <>
                <MobileTopHeader link={true} onLink={"/bankdetailshome"} />
                <div className="pb-4">
                  <TopTextReusableComponent headingText="Terms And Conditions" />
                </div>
              </>
            </Media>
            <div className="onboarding_process_screen-button-map d-flex justify-content-between flex-column">
              <div className="TermBox">
                <Scrollbars style={{ width: "100%", height: "100%" }}>
                  <div className="w-100 h-100 p-4">
                    <Media query="(min-width: 992px)">
                      <div className="pb-4">
                        <TopTextReusableComponent headingText="Terms And Conditions" />
                      </div>
                    </Media>
                    <div className="f13-500 mb-3">General Site Usage</div>
                    <div className="f12-400 mb-3">
                      Last Revised: December 16, 2020
                    </div>
                    <div className="f11-400 mb-3">
                      Welcome to Amealio This site is provided as a service to
                      our visitors and may be used for informational purposes
                      only. Because the Terms and Conditions contain legal
                      obligations, please read them carefully.
                    </div>
                    <div className="f13-700 mb-3">1. YOUR AGREEMENT</div>
                    <div className="f11-400 mb-3">
                      By using this Site, you agree to be bound by, and to
                      comply with, these Terms and Conditions. If you do not
                      agree to these Terms and Conditions, please do not use
                      this site.
                    </div>
                    <div className="f11-400 mb-3">
                      PLEASE NOTE: We reserve the right, at our sole discretion,
                      to change, modify or otherwise alter these Terms and
                      Conditions at any time. Unless otherwise indicated,
                      amendments will become effective immediately. Please
                      review these Terms and Conditions periodically. Your
                      continued use of the Site following the posting of changes
                      and/or modifications will constitute your acceptance of
                      the revised Terms and Conditions and the reasonableness of
                      these standards for notice of changes. For your
                      information, this page was last updated as of the date at
                      the top of these terms and conditions.
                    </div>
                    <div className="f13-700 mb-3">2. PRIVACY</div>
                    <div className="f11-400 mb-3">
                      Please review our Privacy Policy, which also governs your
                      visit to this Site, to understand our practices.
                    </div>
                    <div className="f13-700 mb-3">3. LINKED SITES</div>
                    <div className="f11-400 mb-3">
                      This Site may contain links to other independent
                      third-party Web sites ("Linked Sites”). These Linked Sites
                      are provided solely as a convenience to our visitors. Such
                      Linked Sites are not under our control, and we are not
                      responsible for and does not endorse the content of such
                      Linked Sites, including any information or materials
                      contained on such Linked Sites. You will need to make your
                      own independent judgment regarding your interaction with
                      these Linked Sites.
                    </div>
                    <div className="f13-700 mb-3">
                      4. FORWARD LOOKING STATEMENTS
                    </div>
                    <div className="f11-400 mb-3">
                      All materials reproduced on this site speak as of the
                      original date of publication or filing. The fact that a
                      document is available on this site does not mean that the
                      information contained in such document has not been
                      modified or superseded by events or by a subsequent
                      document or filing. We have no duty or policy to update
                      any information or statements contained on this site and,
                      therefore, such information or statements should not be
                      relied upon as being current as of the date you access
                      this site.
                    </div>
                    <div className="f13-700 mb-3">
                      5. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY
                    </div>
                  </div>
                </Scrollbars>
              </div>
              <div className="f12-400 mt-3 d-flex align-items-center">
                <Form.Check
                  label="1"
                  inline
                  checked={check}
                  onChange={() => setCheck(!check)}
                  className="enCheckBoxOnly"
                  required
                />
                I have read the &nbsp;
                <span className="text-blue"> terms and conditions </span>&nbsp;
                of the agreement.
              </div>
              <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                <ReusableOnboardingLink
                  buttonTitle="Disagree Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  buttonText="Disagree"
                  link="/bankdetailshome"
                />
                <ReusableOnboardingButton
                  buttonTitle="Agree Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                  buttonText="Agree"
                  buttonType="Submit"
                  onClick={onSubScription}
                />
              </div>
              {/* <div className="tcbox onboarding-map-setup-screen-autodetect-button mt-5">
                <ReusableOnboardingLink
                  buttonTitle="Back Button"
                  buttonClass="btn-lg btn btn-outline-secondary"
                  buttonText="Disagree"
                  link="/bankdetailshome"
                />
                <ReusableOnboardingButton
                  buttonTitle="Next Button"
                  buttonClass="btn-lg btn btn-danger pl-5 pr-5 ml-3 "
                  buttonText="Agree"
                  buttonType="Submit"
                  onClick={onSubScription}
                />
              </div> */}
            </div>
          </div>
          <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
            <SliderReusableComponent
              displayBarButton={true}
              displayHamburger={true}
              paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
              bottomImage={require("../../../../assets/images/UserManagement/subscription.svg")}
            />
          </div>
        </div>
      </div>
      <Modal
        show={showSuccess}
        onHide={handleCloseSuccess}
        centered
        className="bg-yellow-modal"
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <Image
            className="w-75 my-4"
            src={require("../../../../assets/images/UserManagement/success2.png")}
          />
          <div className="f24_700_HelveticaNeue text-red text-center pb-4">
            Success!
          </div>
          <div className="f20-500 mobile-16">
            Thank You for Completing Your Profile.
          </div>
          <div className="f11-400 pb-3">
            We will get in touch with you by email in the next couple of days.
          </div>
          <div className="row">
            <div className="col-6">
              <Button
                variant="danger"
                className="w-100 btn-md py-2 mb-2 mobile-p-0"
                onClick={(e) => history.push("/subscription")}
              >
                Continue to Subscription
              </Button>
            </div>
            <div className="col-6">
              <Button
                variant="outline-secondary"
                className="w-100 btn-md py-2 mb-2  mobile-p-0"
                onClick={(e) => onCombackLater()}
              >
                Come Back Later to Complete
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

TermsAndCondition.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  create_and_update_restaurant,
  update_vendor_profile,
  logOutUser,
})(withRouter(TermsAndCondition));

// import React, { Component } from "react";
// import Image from "react-bootstrap/Image";
// import { NavLink } from "react-router-dom";
// import RightSidePannel from "../rightSidePannelReusable/RightSidePannel";
// import Form from "react-bootstrap/Form";
// import {
//   ReusableOnboardingLink,
//   ReusableOnboardingButton,
// } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

// export class TermsAndCondition extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       selectedTab: 4,
//       termsAndCondition: false,
//     };
//   }

//   onHandleSubmit = (e) => {
//     e.preventDefault();
//     // window.location.href = "/locatedinside";
//   };

//   renderDressCodeFields = () => {
//     return (
//       <React.Fragment>
//         <div className="terms-and-condition-main-section"></div>
//         <div className="restaurant_type_onboarding_main">
//           <div className="onboarding-map-setup-screen-autodetect-button">
//             {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
//             <ReusableOnboardingLink
//               buttonTitle="Back Button"
//               buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
//               buttonText="Back"
//               link="/bankdetailshome"
//             />
//             <ReusableOnboardingButton
//               buttonTitle="Next Button"
//               buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red"
//               buttonText="Next"
//               buttonType="submit"
//             />
//             {/* </div> */}
//           </div>
//         </div>
//       </React.Fragment>
//     );
//   };

//   render() {
//     return (
//       <React.Fragment>
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 onboarding_process_screen_left">
//               <div className="col-12 onboarding_process_screen_left-backbutton">
//                 <NavLink to="/bankdetailshome" className="back_button-link">
//                   <Image
//                     src={require("../../../../assets/images/Icon/onBoardBack.png")}
//                     alt="Back Button"
//                     title="Back Button"
//                   />
//                 </NavLink>
//               </div>
//               <div className="onboarding_process_screen-left-mapinside">
//                 <div className="bank_and_other_details_onboarding_main">
//                   <Form noValidate onSubmit={this.onHandleSubmit}>
//                     {this.renderDressCodeFields()}
//                   </Form>
//                 </div>
//               </div>
//             </div>
//             <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 onboarding_process_screen_right">
//               <div className="col-12 onboarding_process_screen_right-backbutton">
//                 <NavLink to="/seatingdashboard" className="back_button-link">
//                   <Image
//                     src={require("../../../../assets/images/Icon/help.png")}
//                     alt="Back Button"
//                     title="Back Button"
//                   />
//                 </NavLink>
//               </div>
//               <div className="onboarding_process_right_paddingBox">
//                 <RightSidePannel
//                   selectedTab={this.state.selectedTab}
//                   headingText="Store Setup"
//                   imageSrc={require("../../../../assets/images/onboarding/storeSetup.svg")}
//                   paragraph="Enter information diligently about your food establishment. Users
//                   would like to know about your restaurant listed on our app. Take your
//                   time and fill information carefully"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </React.Fragment>
//     );
//   }
// }

// export default TermsAndCondition;
//24-06-2020 09:17Am
